import { parse } from 'qs';

/* eslint no-useless-escape:0 */
export const reg =
  /(((^https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+(?::\d+)?|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/;

export const emailRegexp = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;

export const isUrl = (path: string): boolean => reg.test(path);

export const validatePhoneReg = /^1[3-9]\d{9}$/;
export const validatePaywordReg = /^\d{6}$/;
export const validatePasswordReg = /^(?=.*\d)(?=.*[a-zA-Z]).{8,20}$/;
export const isCorrectEmail = (email: string): boolean => reg.test(email);
export const isCorrectPhone = (phone: string): boolean =>
  validatePhoneReg.test(phone);
const validateMap = {
  phone: (_: unknown, value: string) => {
    if (!value || isCorrectPhone(value)) {
      return Promise.resolve();
    }
    return Promise.reject(new Error('请输入正确的手机号码！'));
  },
  email: (_: unknown, value: string) => {
    if (!value || isCorrectEmail(value)) {
      return Promise.resolve();
    }
    return Promise.reject(new Error('请输入正确的邮箱！'));
  },
};
export const validates = (type: 'phone') => validateMap[type];

export const Fen2Yuan = (num: number) => {
  if (typeof num !== 'number' || isNaN(num)) return 0;
  return (num / 100).toFixed(2);
};

export const getUrlSearch = (key: string) => {
  const { search } = location;
  const searchObj = parse(decodeURIComponent(search.slice(1)));
  return searchObj[key];
};

const getNameInfo = (code: string, list?: API.Region[]) => {
  const { name, level, children } =
    list?.find((item) => item.adCode === code) || {};
  return {
    nameObj: { [`${level}`]: name },
    list: children,
  };
};

export const getAreaNames = (codes: string[], allAreas: any) => {
  const areaNamesObj = codes.reduce(
    ({ names, list }, curr) => {
      const nameInfo = getNameInfo(curr, list);
      return {
        names: { ...names, ...nameInfo.nameObj },
        list: nameInfo.list,
      };
    },
    { names: {}, list: allAreas },
  );

  return areaNamesObj.names;
};
// 强制保留2位小数
export const toDecimal2 = (x: number | string) => {
  let _x = parseFloat(String(x));
  if (isNaN(_x)) {
    return undefined;
  }
  let f = Math.round(Number(x) * 100) / 100;
  let s = f.toString();
  let rs = s.indexOf('.');
  if (rs < 0) {
    rs = s.length;
    s += '.';
  }
  while (s.length <= rs + 2) {
    s += '0';
  }
  return s;
};

// 强制保留4位小数
export const toDecimal4 = (x: number | string) => {
  let _x = parseFloat(String(x));
  if (isNaN(_x)) {
    return undefined;
  }
  let f = Math.round(Number(x) * 10000) / 10000;
  let s = f.toString();
  let rs = s.indexOf('.');
  if (rs < 0) {
    rs = s.length;
    s += '.';
  }
  while (s.length <= rs + 4) {
    s += '0';
  }
  return s;
};

export const toPercent = (num: number) => {
  return `${num * 100}%`;
};

export const mallLink = (
  type?: string | undefined,
  link?: string | undefined,
) => {
  // 分类列表页：/category?k={categorId}
  if (type === 'category_link') {
    window.open(`/category?k=${link}`, '_self');
  } else if (type === 'product_link') {
    window.open(`/product/${link}`);
  } else if (type === 'information_link') {
    window.open(`/info/${link}`);
  } else {
    window.open(`${link}`);
  }
};
export const openLink = (url?: string, blank?: boolean) => {
  if (url) {
    if (blank) {
      window.open(url);
    } else {
      window.location.href = `${url}`;
    }
  }
};

export const getUrlparam = () => {
  let url = window.location.href;
  let p = url.split('?')[1];
  let params = new URLSearchParams(p);
  return params.get('type');
};

export const openOnline = () => {
  if (window.BEUKAY_YSF) {
    window.BEUKAY_YSF('open', { templateId: 6642833 });
  }
};

type FormatImageProps = {
  url?: string;
  w?: number;
  h?: number;
  q?: number;
};
export const formatImage = ({ url, ...rest }: FormatImageProps) => {
  if (!url) return;
  if (!rest) return url;
  const { w, h, q } = rest;
  let formatUrl = `${url}?x-oss-process=image`;
  if (w || h) {
    formatUrl = `${formatUrl}/resize`;
    if (!(w && h)) {
      const temp = w || h;
      formatUrl = `${formatUrl},w_${temp},h_${temp}`;
    } else {
      if (w) {
        formatUrl = `${formatUrl},w_${w}`;
      }
      if (h) {
        formatUrl = `${formatUrl},h_${h}`;
      }
    }
  }
  if (q) {
    formatUrl = `${formatUrl}/quality,Q_${q}`;
  }
  return formatUrl;
};

export const LOCALE = {
  setLocale: (locale: string) => window.localStorage.setItem('locale', locale),
  getLocale: () => window.localStorage.getItem('locale'),
};

export const download = ({ url, name }: { url?: string; name?: string }) => {
  if (!url) {
    return;
  }
  const x = new XMLHttpRequest();
  x.open('GET', url, true);
  x.responseType = 'blob';
  x.onload = function () {
    const href = window.URL.createObjectURL(x.response);
    const link = document.createElement('a');
    link.href = href;
    link.download = name || '';
    link.click();
    window.URL.revokeObjectURL(href);
  };
  x.send();
};

export const genAreasMap = (areas: API.Region[]) => {
  const areasMap: Record<string, string> = {};
  const get = (list: API.Region[]) => {
    list.forEach((item) => {
      areasMap[item.adCode!] = item.name!;
      if (item.children) {
        get(item.children);
      }
    });
  };
  get(areas);
  return areasMap;
};
